import { render, staticRenderFns } from "./TagStatus.vue?vue&type=template&id=3023133a&scoped=true"
import script from "./TagStatus.vue?vue&type=script&lang=js"
export * from "./TagStatus.vue?vue&type=script&lang=js"
import style0 from "./TagStatus.vue?vue&type=style&index=0&id=3023133a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023133a",
  null
  
)

export default component.exports